import { Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  fullWidth: {
    justifyContent: 'space-between',
  },
  labelPlacementStart: {
    marginLeft: 0,
  },
  switch: {
    margin: `0 ${theme.spacing(1)}px`,
  },
}));

export const useHelperTextStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
  },
}));
